export const templates = [
  {
    id: "tpl-1",
    name: "Благодарность за положительный отзыв",
    description: "Шаблон для ответа на положительные отзывы (4-5 звезд)",
    category: "благодарность",
    content: "Здравствуйте, {customer_name}!\n\nСпасибо за ваш отзыв! Мы очень рады, что вам понравился {product_name}. Ваше мнение важно для нас.\n\nЖелаем вам приятных покупок!\n\nС уважением,\nКоманда Art-Visage",
    variables: ["customer_name", "product_name"],
    recommended_for: {
      sentiment: ["positive"],
      rating: [4, 5],
      use_case: "Хорошо подходит для стандартных положительных отзывов с оценкой 4-5 звезд"
    },
    is_active: true,
    usage_count: 1234,
    avg_edit_rate: 0.15,
    created_at: "2025-01-10T10:00:00Z",
    updated_at: "2025-01-10T10:00:00Z",
  },
  {
    id: "tpl-2",
    name: "Извинение и решение проблемы",
    description: "Шаблон для ответа на негативные отзывы (1-2 звезды)",
    category: "извинение",
    content: "Здравствуйте, {customer_name}!\n\nМы ценим вашу обратную связь. Нам жаль, что {product_name} не оправдал ваших ожиданий. Мы обязательно учтем ваши замечания и передадим их нашей команде для улучшения качества.\n\n{resolution_text}\n\nЕсли у вас остались вопросы, пожалуйста, свяжитесь с нами.\n\nС уважением,\nКоманда Art-Visage",
    variables: ["customer_name", "product_name", "resolution_text"],
    recommended_for: {
      sentiment: ["negative"],
      rating: [1, 2],
      use_case: "Для негативных отзывов с низкой оценкой, требующих эмпатии и решения проблемы"
    },
    is_active: true,
    usage_count: 456,
    avg_edit_rate: 0.45,
    created_at: "2025-01-11T11:30:00Z",
    updated_at: "2025-01-15T14:20:00Z",
  },
  {
    id: "tpl-3",
    name: "Нейтральный ответ",
    description: "Шаблон для ответа на нейтральные отзывы (3 звезды)",
    category: "общие",
    content: "Здравствуйте!\n\nСпасибо за ваш отзыв о {product_name}. Мы ценим ваше мнение и постоянно работаем над улучшением качества наших продуктов.\n\nБудем рады видеть вас снова!\n\nС уважением,\nКоманда Art-Visage",
    variables: ["product_name"],
    recommended_for: {
      sentiment: ["neutral"],
      rating: [3],
      use_case: "Для нейтральных отзывов со средней оценкой"
    },
    is_active: true,
    usage_count: 234,
    avg_edit_rate: 0.22,
    created_at: "2025-01-12T09:15:00Z",
    updated_at: "2025-01-12T09:15:00Z",
  },
  {
    id: "tpl-4",
    name: "Запрос дополнительной информации",
    description: "Шаблон для запроса уточнений у клиента",
    category: "вопросы",
    content: "Здравствуйте, {customer_name}!\n\nСпасибо за ваш отзыв о {product_name}. Для того чтобы мы могли лучше разобраться в ситуации, не могли бы вы предоставить дополнительную информацию:\n\n{questions}\n\nЭто поможет нам улучшить качество наших продуктов.\n\nС уважением,\nКоманда Art-Visage",
    variables: ["customer_name", "product_name", "questions"],
    recommended_for: {
      sentiment: ["negative", "neutral"],
      rating: [1, 2, 3],
      use_case: "Когда нужны дополнительные детали для решения проблемы"
    },
    is_active: true,
    usage_count: 89,
    avg_edit_rate: 0.67,
    created_at: "2025-01-13T16:45:00Z",
    updated_at: "2025-01-13T16:45:00Z",
  },
  {
    id: "tpl-5",
    name: "Ответ на вопрос о составе",
    description: "Шаблон для ответа на вопросы о составе продукта",
    category: "вопросы",
    content: "Здравствуйте!\n\nСпасибо за ваш интерес к {product_name}. Состав продукта можно найти на упаковке или на нашем официальном сайте в разделе описания товара.\n\n{additional_info}\n\nЕсли у вас есть дополнительные вопросы, мы будем рады ответить!\n\nС уважением,\nКоманда Art-Visage",
    variables: ["product_name", "additional_info"],
    recommended_for: {
      sentiment: ["neutral"],
      rating: [],
      use_case: "Для вопросов о составе продукта"
    },
    is_active: false,
    usage_count: 23,
    avg_edit_rate: 0.18,
    created_at: "2025-01-14T12:00:00Z",
    updated_at: "2025-01-14T12:00:00Z",
  },
];
